import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
import { clsx } from 'clsx';
import { I18nInfo } from '@/user/models';
import { getBadgeColor, getBadgeText } from '@/user/models/common/level-badge';
import { Badge, SpriteIcons } from '@/user/components/common/';
import store from '@/user/store';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeCurriculum',
    setup(__props) {
        const router = useRouter();
        const t = new I18nInfo('eduCenter.home.sectionCurriculum');
        const lectures = computed(() => store.getters['HomeStore/activatedLectures']);
        const styles = {
            container: clsx('flex flex-row gap-16 pl-16 pr-16 mt-24 overflow-x-auto', 'desktop:flex-row desktop:px-0'),
            item: clsx('shrink-0 h-full', 'desktop:w-[calc((100%-32px)/3)]'),
            itemLink: clsx('w-312 h-full flex flex-col rounded-12 overflow-hidden group text-left border-1 border-gray-250 hover:border-blue-700', 'desktop:w-full'),
            imageCover: clsx('w-full h-150', 'desktop:h-160'),
            image: clsx('w-full h-full object-cover'),
            infoBox: clsx('flex flex-col p-20 bg-white flex-1', 'desktop:p-24'),
            subtitle: clsx('block mt-12 text-title-2 line-clamp-2 h-[3.5rem]', 'desktop:text-title-1 desktop:h-[3.5rem]'),
            description: clsx('text-body-5 text-gray-800 mt-8 line-clamp-3 h-[4.125rem] mb-24', 'desktop:text-body-4 desktop:h-[5rem] desktop:mb-32'),
            arrowIcon: clsx('mt-auto ml-auto h-24 w-24 text-gray-400 group-hover:text-blue-700 transition-colors'),
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", {
                class: _normalizeClass(styles.container)
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(lectures.value), (lecture, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: idx,
                        class: _normalizeClass(styles.item)
                    }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(styles.itemLink),
                            onClick: ($event) => (_unref(router).push({ name: 'AttendDetail', params: { id: lecture.id } }))
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.imageCover)
                            }, [
                                _createElementVNode("img", {
                                    class: _normalizeClass(styles.image),
                                    src: `/images/renewal/firststep_bg_${idx + 1}.png`,
                                    alt: ""
                                }, null, 10, _hoisted_2)
                            ], 2),
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.infoBox)
                            }, [
                                _createVNode(_unref(Badge), {
                                    color: _unref(getBadgeColor)(lecture.level)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(getBadgeText)(lecture.level)), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["color"]),
                                _createElementVNode("strong", {
                                    class: _normalizeClass(styles.subtitle),
                                    title: lecture.title
                                }, _toDisplayString(lecture.title), 11, _hoisted_3),
                                _createElementVNode("p", {
                                    class: _normalizeClass(styles.description)
                                }, _toDisplayString(_unref(t).translate(`desc.${lecture.level}`)), 3),
                                _createVNode(_unref(SpriteIcons), {
                                    name: "line-arrow-right",
                                    class: _normalizeClass(styles.arrowIcon)
                                }, null, 8, ["class"])
                            ], 2)
                        ], 10, _hoisted_1)
                    ], 2));
                }), 128))
            ], 2));
        };
    }
});
